import React from 'react';
import IconButton from '@/ctComponents/IconButton';
import styles from './LiveUnloadPlannerCard.module.css';

export const PLANNER_CARD_DEFAULT_HEADER_HINT =
  'Target = delivery time + unloading time + drive to port';

export function PlannerCardHeader({
  headerHint,
  showReturnAppointment,
  onReturnAppointmentClick,
}) {
  const hint =
    headerHint === undefined || headerHint === null
      ? PLANNER_CARD_DEFAULT_HEADER_HINT
      : headerHint;

  return (
    <header className={styles.header}>
      <div className={styles.headerBadges}>
        {showReturnAppointment ? (
          <IconButton
            onClick={onReturnAppointmentClick}
            icon="appointment"
            text="Appointments"
            color="#131517"
            border="1px solid #131517"
            size="normal"
            style={{ padding: '12px 15px', gap: '14px' }}
          />
        ) : null}
      </div>
      {hint !== '' ? <p className={styles.headerHint}>{hint}</p> : null}
    </header>
  );
}
